import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { Map, tileLayer, marker, featureGroup, icon } from "leaflet";
import { GeocodingModel } from "src/app/models/location.model";
import { ProfileModel } from "src/app/models/profile.model";
import { TourneeModel } from "src/app/models/tournee.model";
import { DateService } from "src/app/services/date/date.service";

@Component({
  selector: "map",
  templateUrl: "./map.component.html",
  styleUrls: ["./map.component.scss"]
})
export class MapComponent implements OnInit {
  @Input()
  profiles: ProfileModel[];

  @Input()
  sales: TourneeModel[];

  @Input()
  zoom: number = 15;

  @Input()
  mode: string; // consumer, producer

  @Input()
  mainPoint: GeocodingModel;

  map: Map;

  constructor(private dateService: DateService) {}

  ngAfterViewInit() {
    console.log("after view init");
    //this.map.invalidateSize();
  }
  ngOnInit() {
    console.log(this.mainPoint, this.profiles, this.sales);
    //this.loadMap();
  }

  ngOnDestroy() {
    //this.map.remove();
  }

  loadMap(): void {
    this.map = new Map("map", { attributionControl: false }).setView([this.mainPoint.latitude, this.mainPoint.longitude], this.zoom);
    tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(this.map); // This line is added to add the Tile Layer to our map
    this.addMarkers();
    this.map.whenReady(this.onMapReady);
  }

  onMapReady(map: Map): void {
    console.log("map ready");
    // setTimeout(() => {
    //   console.log('map ready');
    //   this.map.invalidateSize();
    // }, 0);
  }

  async addMarkers(): Promise<void> {
    const markerArray = [];
    for (const profile of this.profiles) {
      if(profile.details.geocoding){
        const customIcon = this.createIcon(profile.role);
        const newMarker = new marker([profile.details.geocoding.latitude, profile.details.geocoding.longitude], {
          draggable: false,
          icon: customIcon
        });

        newMarker.profile = profile;
        //newMarker.on('click', this.markerOnClick,this);
        newMarker.addTo(this.map);
        markerArray.push(newMarker);
        profile.mapMarker = newMarker;        
      }
    }
    for (const sale of this.sales) {
      if(sale.details.geocoding){
        const customIcon = this.createIcon(sale.details.type);
        const newMarker = new marker([sale.details.geocoding.latitude, sale.details.geocoding.longitude], {
          draggable: false,
          icon: customIcon
        });

        newMarker.sale = sale;
        //newMarker.on('click', this.markerOnClick,this);
        newMarker.addTo(this.map);
        markerArray.push(newMarker);
        sale.mapMarker = newMarker;        
      }
      
    }
    const group = new featureGroup(markerArray);
    this.map.fitBounds(group.getBounds());
    //this.map.invalidateSize();
  }

  getGoogleMarkerIcon(role: string): string {
    return "/assets/icon/pins/" + role + ".png";
  }

  createIcon(role: string) {
    return icon({
      iconUrl: "/assets/icon/pins/" + role + ".png",
      iconSize: [25, 35],
      iconAnchor: [12, 35]
    });
  }
  formatDate(date: string): string {
    return this.dateService.formatToLongDate(date);
  }
}
